import CouponList from '@/views/webpc/CashierDesk/CouponListApp/CouponList'

// 定义路由路径数列表
export default [{
  path: '/couponWebpcList',
  name: '优惠劵列表 ',
  component: CouponList
}]



// WEBPACK FOOTER //
// ./src/views/webpc/CashierDesk/CouponListApp/routers/index.js